import React, { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { FetchUserBOCIdByADB2CId } from "../../../../../actions/Web/Customer/SignUp";
import ErrorPage from "../../../../../components/shared/errorPage/ErrorPage";
import Loader from "../../../../../components/shared/loader/Loader";
import { LOCALSESSIONDATAKEYS } from "../../../../../constants/AppConstants";
import { WebCustomerRoutePaths } from "../../../../../constants/Routes";
import { setLocalSessionData } from "../../../../../utils/Authentication/handleUserSession";

const VerifyUserAccount = () => {
    const dispatch = useDispatch();
    const { inProgress, accounts } = useMsal();
    const BOCUserDetails = useSelector(state => state.GetUserBOCIdByADB2CId);
    const {
        userDeviceList_error,
        userDeviceList_success
    } = useSelector(state => state.ROOTREDUCER_RTK.GetUserEnrolledDevicesService);

    useEffect(() => {
        if (inProgress === InteractionStatus.None) {
            setLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID, accounts[0].idTokenClaims.sub);
            dispatch(FetchUserBOCIdByADB2CId());
        }
        // eslint-disable-next-line
    }, [inProgress])

    if (BOCUserDetails.error) {
        return <ErrorPage errorInfo={BOCUserDetails.error}></ErrorPage>
    }

    /** Display error page when GetUserEnrolledDevices fails */
    if (userDeviceList_error) {
        return <ErrorPage errorInfo={userDeviceList_error}></ErrorPage>
    }

    if (BOCUserDetails.success && !BOCUserDetails.data.userId) {
        return <Redirect to={WebCustomerRoutePaths.CREATE_ACCOUNT}></Redirect>
    }

    /** check if userDeviceList_success(GetUserEnrolledDevices response) is successful 
     * and then only redirect to next pages of web pre-enrollment process
     * Because max 5 devices limit validation is happening inside GetUserEnrolledDevices response */
    if (BOCUserDetails.success && BOCUserDetails.data.userId && userDeviceList_success) {
        return <Redirect to={{ pathname: WebCustomerRoutePaths.PROCESS_ACCOUNT, state: { BOCUserId: BOCUserDetails.data.userId } }}></Redirect>
    }

    return (
        <Loader />
    );
}

export default VerifyUserAccount;